import { Alert } from "@interstate/components/Alert";
import { VehicleApiErrorType } from "@coxauto-ui/cxm/communications/api";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface VehicleInsertErrorAlertProps {
  vehicleLabel: string;
  errorType: VehicleApiErrorType;
  onClose: () => void;
}

export function VehicleInsertErrorAlert({
  vehicleLabel,
  errorType,
  onClose
}: VehicleInsertErrorAlertProps) {
  const message =
    errorType === "not_found"
      ? ErrorMessages.VEHICLE_INSERT_NOT_FOUND_ERROR.replace(
          "{vehicleType}",
          vehicleLabel
        )
      : ErrorMessages.VEHICLE_INSERT_GENERIC_ERROR.replace(
          "{vehicleType}",
          vehicleLabel
        );

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="vehicle-insert-error-alert"
        displayCloseButton={true}
        id="VehicleInsertErrorAlert"
        role="info"
        type="info"
        onCloseClick={onClose}
      >
        <span>{message}</span>
      </Alert>
    </StyledContainerAlert>
  );
}

export default VehicleInsertErrorAlert;
